export const useSeo = (title?: MaybeRef<string>) => {
  const defaultTitle = "nowoczesna stodoła";

  const titleTemplate = (part?: string) =>
    (part !== unref(title) ? `${part} - ${unref(title)}` : unref(title)) ||
    defaultTitle;

  return { defaultTitle, titleTemplate };
};
